import React from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'

import AccessLevelPortfolio from './accessLevelPortfolio'
import { AppStateType } from '../../../../../bll/store'
import { addGroups, clearGroups, deleteGroups, editGroups, getGroups } from '../../../../../bll/settings/settingOperations'
import errorHandler from '../../../../../bll/errorHandler'
import openNotification from '../../../../_ui/notification'

const AccessLevelPortfolioContainer = (props: any) => {
    const [isVisibleLoaderLevelsOperator, setIsVisibleLoaderLevelsOperator] = React.useState(false) // Видимость загрузчика при загрузке уровней доступа оператора

    const [checkedAllAssignedGroupsCount, setCheckedAllAssignedGroupsCount] = React.useState(0) // Выбранное количество назначенных групп
    const [checkedAllUnassignedGroupsCount, setCheckedAllUnassignedGroupsCount] = React.useState(0) // Выбранное количество не назначенные групп

    const [getFilterAssignedGroups, setFilterAssignedGroups] = React.useState('') // Фильтр не назначенные группы
    const [getFilterUnassignedGroups, setFilterUnassignedGroups] = React.useState('') // Фильтр назначенные группы

    React.useEffect(() => {
        setIsVisibleLoaderLevelsOperator(true)

        props.getGroups(props.selectedOperatorID).then((result: any) => {
            setIsVisibleLoaderLevelsOperator(false)

            switch (result?.code) {
                case "ERR_QUERY_STRING": { return openNotification("Список уровней доступа...", props.msg.err_0032, "error", "bottomRight") }
                default: errorHandler(result?.code, props.msg); break
            }
        })

        return () => {
            props.clearGroups()
        }
    }, []) // eslint-disable-line react-hooks/exhaustive-deps


    // Выбор назначенных групп
    const onChangeAssignedGroups = (groupName: any, isChecked: boolean) => {
        const currentList = [...props.assignedGroupsList]

        currentList.forEach(i => {
            if (i.groupName === groupName) {
                i.isSelected = isChecked

                if (isChecked) {
                    setCheckedAllAssignedGroupsCount(checkedAllAssignedGroupsCount + 1)
                }
                else { setCheckedAllAssignedGroupsCount(checkedAllAssignedGroupsCount - 1) }
            }
        })

        props.editGroups(currentList, props.unassignedGroupsList) // Обновляем список назначенных групп
    }

    // Удаление уровней доступа
    const onClickMoveAssignedGroups = () => {
        let groupNames: any[] = []
        setIsVisibleLoaderLevelsOperator(true)

        props.assignedGroupsList.forEach((group: any) => {
            if (group.isSelected === true) {
                groupNames.push({
                    name: group.groupName
                })
            }
        })

        props.deleteGroups(props.selectedOperatorID, groupNames).then((result: any) => {
            setIsVisibleLoaderLevelsOperator(false)

            switch (result?.code) {
                case "ERR_QUERY_STRING": { return openNotification("Удаление уровней доступа...", props.msg.err_0033, "error", "bottomRight") }
                default: errorHandler(result?.code, props.msg); break
            }
        })

        setCheckedAllAssignedGroupsCount(0)
    }

    // Функция по выбору всех назначенных групп
    const onChangeSelectedAllAssignedGroups = (isChecked: boolean) => {
        const currentList = [...props.assignedGroupsList]

        currentList.forEach(i => {
            i.isSelected = isChecked
        })

        if (isChecked) {
            setCheckedAllAssignedGroupsCount(currentList.length)
        } else { setCheckedAllAssignedGroupsCount(0) }

        props.editGroups(currentList, props.unassignedGroupsList) // Обновляем список назначенных групп
    }


    // Выбор не назначенных групп
    const onChangeUnassignedGroups = (groupName: any, isChecked: boolean) => {
        const currentList = [...props.unassignedGroupsList]

        currentList.forEach(i => {
            if (i.groupName === groupName) {
                i.isSelected = isChecked

                if (isChecked) {
                    setCheckedAllUnassignedGroupsCount(checkedAllUnassignedGroupsCount + 1)
                }
                else { setCheckedAllUnassignedGroupsCount(checkedAllUnassignedGroupsCount - 1) }
            }
        })

        props.editGroups(props.assignedGroupsList, currentList) // Обновляем список не назначенных групп
    }

    // Добавление уровней доступа
    const onClickMoveUnassignedGroups = () => {
        let groupNames: any[] = []
        setIsVisibleLoaderLevelsOperator(true)

        props.unassignedGroupsList.forEach((group: any) => {
            if (group.isSelected === true) {
                groupNames.push({
                    name: group.groupName
                })
            }
        })

        props.addGroups(props.selectedOperatorID, groupNames).then((result: any) => {
            setIsVisibleLoaderLevelsOperator(false)

            switch (result?.code) {
                case "ERR_QUERY_STRING": { return openNotification("Добавление уровней доступа...", props.msg.err_0034, "error", "bottomRight") }
                default: errorHandler(result?.code, props.msg); break
            }
        })

        setCheckedAllUnassignedGroupsCount(0)
    }

    // Функция по выбору всех не назначенных групп
    const onChangeSelectedAllUnassignedGroups = (isChecked: boolean) => {
        const currentList = [...props.unassignedGroupsList]

        currentList.forEach(i => {
            i.isSelected = isChecked
        })

        if (isChecked) {
            setCheckedAllUnassignedGroupsCount(currentList.length)
        } else { setCheckedAllUnassignedGroupsCount(0) }

        props.editGroups(props.assignedGroupsList, currentList) // Обновляем список не назначенных групп
    }


    // Свойства передаваемые к компоненту
    const propsToAccessLevelPortfolio = {
        isVisibleLoaderLevelsOperator, // Видимость загрузчика при загрузке уровней доступа оператора

        onChangeAssignedGroups, onChangeSelectedAllAssignedGroups, // Выбор (Выбор всех) назначенных групп
        onChangeUnassignedGroups, onChangeSelectedAllUnassignedGroups, // Выбор (Выбор всех) не назначенных групп
        
        onClickMoveAssignedGroups, // Удаление уровней доступа
        onClickMoveUnassignedGroups, // Добавление уровней доступа

        getFilterAssignedGroups, setFilterAssignedGroups, // Фильтр не назначенные группы
        getFilterUnassignedGroups, setFilterUnassignedGroups, // Фильтр назначенные группы

        checkedAllAssignedGroupsCount, checkedAllUnassignedGroupsCount, // Выбранное количество назначенных групп (не назначенных)
    }

    return (
        <AccessLevelPortfolio {...props} {...propsToAccessLevelPortfolio} />
    )
}

let mapState = (state: AppStateType) => {
    return {
        msg: state.msg,
        assignedGroupsList: state.settings.assignedGroupsList,
        unassignedGroupsList: state.settings.unassignedGroupsList,
    }
}

export default compose(connect(mapState, { getGroups, clearGroups, editGroups, addGroups, deleteGroups }))(AccessLevelPortfolioContainer)